
export const PAYMENT_FREQUENCIES = {
  ONE_TIME: 'oneTime',
  CUSTOM: 'custom',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  TWICE_A_MONTH: 'twiceAMonth',
  QUARTERLY: 'quarterly',
} as const;

export const DAY_OF_WEEK = {
  SUNDAY: 'sunday',
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
} as const;

export const SEMI_MONTHLY_OPTIONS = {
  FIRST_AND_FIFTEENTH: 'firstAndFifteenth',
  FIFTEENTH_AND_LAST: 'fifteenthAndLast',
} as const;

export type PaymentFrequency = typeof PAYMENT_FREQUENCIES[keyof typeof PAYMENT_FREQUENCIES];

export type DayOfWeek = typeof DAY_OF_WEEK[keyof typeof DAY_OF_WEEK];

export type SemiMonthlyOption = typeof SEMI_MONTHLY_OPTIONS[keyof typeof SEMI_MONTHLY_OPTIONS];

export type PaymentScheduleModel = {
  frequency: PaymentFrequency;
  startDate: Date;
  endDate: Date;
} & (
      | {
        frequency: typeof PAYMENT_FREQUENCIES.ONE_TIME;
      }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.CUSTOM;
      customDates: string[];
    }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.WEEKLY;
      dayOfWeek: DayOfWeek;
    }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.MONTHLY;
    }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.TWICE_A_MONTH;
      semiMonthlyOption: SemiMonthlyOption;
    }
    | {
      frequency: typeof PAYMENT_FREQUENCIES.QUARTERLY;
    }
);

export type PaymentScheduleExport = string[];




